<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px">
      <el-button type="primary" @click="showBox({})" style="color: #FFFFFF">新增</el-button>
      <el-button @click="search()">查询</el-button>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="项目">
          <el-input size="mini" placeholder="" v-model="params.project_name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="流程名称">
          <el-input size="mini" placeholder="请输入流程名称" v-model="params.flow_name" clearable></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>


    <div style="margin-top: 10px;">
<!--      <span style="color:red">加载中...</span>-->
    </div>
    <el-table ref="Table" v-if="list" :data="list" height="680px">
      <el-table-column prop="ancestor_name" label="项目" align="center"></el-table-column>
      <el-table-column prop="master_name"label="流程名称" align="center"></el-table-column>
      <el-table-column prop="node"label="节点审批人" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" style="color: #FFFFFF" @click="showBox(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" style="color: #FFFFFF" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="params.total"
                   :current-page="params.page"
                   :page-size="params.pageSize"
                   :page-sizes="[50, 100, 500]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

    <el-dialog title="新增" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-input v-model="formData.id" type="hidden"></el-input>
        <el-descriptions class="margin-top" title="" :column="1" size="mini" border>
          <el-descriptions-item label="项目">
            <div>
              <el-select v-model="formData.project_id" filterable placeholder="请选择" size="mini" style="width: 100%">
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.ancestor_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="流程">
            <el-select v-model="formData.master_id" filterable placeholder="请选择" size="mini" style="width: 100%" @change="getFlowMasterInfo()">
              <el-option
                v-for="item in flowMasterList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <template v-for="(item, index) in flowSheetInfo">
            <el-descriptions-item v-if="item.type === 'user'" :label="item.text.value">
              <div>
                <el-button size="mini" @click="selectPersonnel(item)">选择审批人</el-button>
              </div>
              <div v-if="nodeList[item.id]">
                {{nodeList[item.id]['ancestor_name']}} {{nodeList[item.id]['name']}}
              </div>
            </el-descriptions-item>
          </template>

        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="saveForm()">确认</el-button>
      </div>
    </el-dialog>
    <select-personnel ref="selectPersonnel" />
  </div>
</template>
<script>
import SelectPersonnel from "../../Personnel/components/selectPersonnel";
import Http from "../common/Http";
import _ from "lodash";

export default {
  name: 'FlowConfingList',
  components: {SelectPersonnel},
  data() {
    return {
      params: {
        project_name: "",
        flow_name: "",
        total: 0,
        page: 1,
        pageSize: 20
      },
      list: [],
      projectList: [],
      flowMasterList: [],
      flowSheetInfo: [],
      dialogVisible: false,
      formData: {},
      nodeList:{},
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    this.getList()
    this.getProjectList()
    this.getFLowMasterList()
  },
  methods: {

    search() {
      this.params.page = 1;
      this.getList()
    },
    showBox(item) {
      console.info(item)
      this.formData = item
      // 编辑
      if (Object.keys(item).length > 0) {
        this.getFlowMasterInfo()
      }
      this.dialogVisible = true
    },
    saveForm() {
      let that = this
      let params = this.formData
      params.nodeList = this.nodeList
      Http.post(Http.getPreBaseURL() + "/oa/FlowConfig/addFlowConfig", params, res => {
        if (res.code == 0) {
          that.getList()
          that.dialogVisible = false
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    getList() {
      let params = this.params
      Http.get(Http.getPreBaseURL() + '/oa/FlowConfig/getFlowConfigList', params, res => {
        if (res.code === 0) {
          this.list = res.data.data;
          this.params.page = res.data.current_page;
          this.params.pageSize = res.data.per_page;
          this.params.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    del(id) {
      let params = {id : id};
      // Http.get(Http.getPreBaseURL() + '/oa/user/delUserRole', params, res => {
      //   if (res.code === 0) {
      //     this.$message.success({
      //       message: res.msg,
      //       type: "success",
      //     })
      //     this.getList()
      //   } else {
      //     this.$message.error({
      //       message: res.msg,
      //       type: "error",
      //     })
      //   }
      // })
    },
    edit(id) {

    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },
    getProjectList() {
      let that = this
      Http.get(Http.getPreBaseURL() + '/oa/user/projectList', {}, res => {
        if (res.code === 0) {
          that.projectList = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    getFLowMasterList() {
      let that = this
      let params = {
        page : 1,
        pageSize : 10000,
      }
      Http.get(Http.getPreBaseURL() + '/oa/flow/getList', params, res => {
        if (res.code === 0) {
          that.flowMasterList = res.data.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    getFlowMasterInfo() {
      let that = this
      that.flowSheetInfo = []
      that.nodeList = {}
      let params = {
        master_id : that.formData.master_id,
      }
      Http.get(Http.getPreBaseURL() + '/oa/flow/getSheetInfoByMasterId', params, res => {
        if (res.code === 0) {
          that.flowSheetInfo = res.data.graph_data.nodes
          let list = res.data.graph_data.nodes
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    selectPersonnel(node){
      let that = this
      let nodeArr = {}
      this.$refs.selectPersonnel.show({},function (data) {
        let info = {
          name : '',
          ancestor_name : '',
          id : '',
        }
        info.name = data[0]['name']
        info.ancestor_name = data[0]['ancestor_name']
        info.id = data[0]['id']

        nodeArr = that.nodeList
        nodeArr[node.id] = info
        that.nodeList = Object.assign({}, nodeArr)
      })
    },

  }
}
</script>
<style lang="scss" scoped>
$widths: 100px;
.month-table {
  border-color: gray;
  border-collapse: separate;
  user-select: none;
  font-size: 12px;
  min-width: 1200px;
  min-height: 100px;

  tr:hover {
    td.fixed {
      background-color: #dddddd;
      border: 1px solid #ebeef5;
      color: #000;
    }
  }

  th, td {
    min-width: 24px;
    padding: 5px 0px;

    &.fixed {
      position: sticky;
      cursor: pointer;
      z-index: 2;
    }
  }

  th {
    background: #f5f7fa;
    color: #909399;
    border: 1px solid #ebeef5;

    &.hover {
      background-color: #ffebbe;
      color: #333;
    }
  }

  td {
    color: #606266;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    text-align: center;
    overflow: hidden;

    &:first-child {
      border-left: 1px solid #ebeef5;
    }

    &.day-item {
      &.check {
        //background: #fafafa;
        opacity: .5;
      }

      &.changed {
        background: #fd9dca;
        color: #333;
      }

      &.selected {
        background: #409eff;
        color: #409eff;
      }
    }

    &.fixed {
      background-color: #fafafa;
    }

    .work-class-label {
      display: inline-block;
    }
  }

  .department-name {
    box-sizing: border-box;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 78px;
    padding: 0 3px;
    line-height: 20px;
  }

  &.show-department {
    .department-name {
      text-overflow: unset;
      overflow: visible;
      white-space: normal;
      width: 198px;
    }
  }

  .inp {
    box-sizing: border-box;
    width: 100%;
    min-width: 50px;
    text-align: center;
    border: 1px solid #fff;
    outline: none;
    font-size: 12px;
    border-radius: 3px;

    &:hover, &:focus {
      border-color: #ccc;
    }
  }

  .w80 {
    display: inline-block;
    width: 79px;
  }

}

.day-head {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreUser/FlowConfingList.vue